import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import RequireAuth from "@/components/RequireAuth";

import Home from "@/pages/Home";
import Brands from "@/pages/Brands";
import BrandShowcase from "@/pages/BrandShowcase";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Payment from "@/pages/Payment";
import OrderSuccess from "@/pages/OrderSuccess";
import StoreLocator from "@/pages/StoreLocator";
import Franchise from "@/pages/Franchise";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Orders from "@/pages/Orders";

// Admin
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminOrders from "@/pages/admin/Orders";
import AdminUsers from "@/pages/admin/Users";
import AdminPayments from "@/pages/admin/Payments";
import AdminFranchise from "@/pages/admin/FranchiseLeads";
import AdminContact from "@/pages/admin/ContactInbox";
import AdminEnquiries from "@/pages/admin/Enquiries";
import AdminSettings from "@/pages/admin/Settings";

function StorefrontShell() {
  return (
    <>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <ScrollToTop />
            <Routes>
              {/* Admin (no Navbar/Footer — own shell) */}
              <Route
                path="/admin"
                element={
                  <RequireAuth adminOnly>
                    <AdminLayout />
                  </RequireAuth>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="payments" element={<AdminPayments />} />
                <Route path="franchise" element={<AdminFranchise />} />
                <Route path="contact" element={<AdminContact />} />
                <Route path="enquiries" element={<AdminEnquiries />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              {/* Storefront */}
              <Route element={<StorefrontShell />}>
                <Route path="/" element={<Home />} />
                <Route path="/brands" element={<Brands />} />
                <Route path="/brands/:slug" element={<BrandShowcase />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/login" element={<Login />} />
                <Route path="/checkout" element={<RequireAuth><Checkout /></RequireAuth>} />
                <Route path="/checkout/payment" element={<RequireAuth><Payment /></RequireAuth>} />
                <Route path="/checkout/success" element={<RequireAuth><OrderSuccess /></RequireAuth>} />
                <Route path="/account/orders" element={<RequireAuth><Orders /></RequireAuth>} />
                <Route path="/locations" element={<StoreLocator />} />
                <Route path="/franchise" element={<Franchise />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Home />} />
              </Route>
            </Routes>
            <Toaster
              position="bottom-right"
              theme="light"
              richColors
              toastOptions={{
                style: {
                  fontFamily: "Inter, sans-serif",
                  borderRadius: 0,
                  border: "1px solid #e5dec9",
                },
              }}
            />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
